import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { flatMap } from "lodash";

import { UseQuery, QueryResult } from "@zapier/checkout/esm/types";
import { changePlan_plansQuery as PlansQuery } from "@zapier/checkout/esm/graphql-types";

export const plansQuery = gql`
  query changePlan_plansQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      currentPlan: planV2 {
        id
        interval
        name
      }
    }

    planStacks: pricingPageV3Plans(accountId: $accountId) {
      id
      plans {
        allowCompanies
        amount
        hasMeteredBilling
        hasTeams
        id
        interval
        name
        tasks
        tiers {
          numTasks
          pricePerTask
        }
        type
        zaps
      }
    }
  }
`;

type Options = {
  skip?: boolean;
};

export const usePlans = (
  accountId: number,
  options: Options = {},
  useQuery: UseQuery = defaultUseQuery
) => {
  const { data, error, loading }: QueryResult<PlansQuery> = useQuery(
    plansQuery,
    {
      skip: Boolean(options.skip),
      variables: {
        accountId,
      },
    }
  );

  return {
    currentPlan: data?.account?.currentPlan,
    error: error
      ? "There was an issue loading plan data. Please try again."
      : null,
    isLoading: loading,
    plans: flatMap(data?.planStacks ?? [], planStack => planStack.plans),
  };
};
